export default "<p>update-picture works!</p>\r\n";